import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ProtectedRoutes from "./ProtectedRoutes";
import en_ja from "../translations/en_ja";

const DycRouteSettingConfig = ({ routeLayout, protectRoute, routeList }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    const currentRoute = routeList.find(route =>
      location.pathname.includes(route.path)
    );
    if (currentRoute?.label) {
      document.title = `${currentRoute.label} | ${en_ja["SJ - Admin Portal"]}`;
    } else {
      document.title = en_ja["SJ - Admin Portal"];
    }
  }, [location, routeList]);

  const isFlat = !routeLayout;

  return (
    <Routes>
      {isFlat ? (
        <>
          {routeList.map((route, idx) => (
            <Route key={idx} path={route.path} element={route.element} />
          ))}
          {/* ✅ Don't render <></> — just don't match unknown routes */}
        </>
      ) : (
        <Route
          path="/"
          element={
            protectRoute
              ? <ProtectedRoutes>{routeLayout}</ProtectedRoutes>
              : routeLayout
          }
        >
          {routeList.map((route, idx) => (
            <Route key={idx} path={route.path} element={route.element} />
          ))}
        </Route>
      )}
    </Routes>
  );
};

export default DycRouteSettingConfig;